<template>
  <div>
    <div style="height: 36px;">
      <h3 class="font-size-lg text-dark font-weight-bold mb-6 telefone-title">
        Telefones:
      </h3>
      <a
        href="javascript:;"
        @click="adicionar"
        class="btn btn-light-primary btn-sm font-weight-bolder mr-2 btn-adicionar"
      >
        <i v-if="!loading" class="ki ki-plus icon-sm"></i> Adicionar
      </a>
    </div>

    <b-list-group class="list-scroll" style="max-height: 258px; overflow-y: auto;">
      <b-list-group-item v-for="(telefone, index) in telefones" :key="telefone.ID_EMITENTE_TELEFONE_TODOS">
        <div class="row">
          <div class="col-md-12">
            <button type="button" aria-label="Remover" class="close" @click="remover(index)">
              <div class="alert-close">
                <span aria-hidden="true"><i class="la la-close"></i></span>
              </div>
            </button>
          </div>
        </div>
        <div class="row" style="margin-bottom: 16px;">
          <div class="col-md-2" style="padding-top: 8px; padding-bottom: 12px;">
            <b-form-group style="margin-bottom: 0px;">
                <b-form-checkbox
                  v-model="telefone.TEL_CHAMADA"
                  name="TEL_CHAMADA"
                  value="1"
                  unchecked-value="0"
                >
                  Tel.Entrada
              </b-form-checkbox>
              <b-form-checkbox
                  v-model="telefone.E_CELULAR"
                  name="E_CELULAR"
                  value="1"
                  unchecked-value="0"
                >
                  Celular
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group label="Tipo:" style="margin-bottom: 0px;">
              <b-form-select
                v-model="telefone.TIPO"
                :options="tiposTelefone"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group label="Operadora:" style="margin-bottom: 0px;">
              <b-form-select
                v-model="telefone.OPERADORA"
                :options="operadoras"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group label="DDI:">
              <b-form-input
                type="text"
                v-model="telefone.DDI"
                placeholder="DDI"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="DDD:">
              <b-form-input
                type="text"
                v-model="telefone.DDD"
                placeholder="DDD"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Telefone:">
              <b-form-input
                type="text"
                v-model="telefone.TELEFONE"
                placeholder="Telefone"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Complemento:">
              <b-form-input
                type="text"
                v-model="telefone.COMPLEMENTO"
                placeholder="Complemento"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Apelido:">
              <b-form-input
                type="text"
                v-model="telefone.APELIDO"
                placeholder="Apelido"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <DatasInclusaoAlteracao v-if="telefone.DATA_INCLUSAO"
              :dataInclusao="formatarData(telefone.DATA_INCLUSAO)" 
              :dataAlteracao="(telefone.DATA_ALTERACAO) ? formatarData(telefone.DATA_ALTERACAO) : ''" 
              :usuarioInclusao="telefone.USUARIO_INCLUSAO" 
              :usuarioAlteracao="telefone.USUARIO"
            />
          </div>
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="!telefones.length">
        <div class="row">
          <div class="col-md-12">
            <h3 class="font-size-lg text-dark font-weight-bold mb-6" style="font-size: 12px; margin-top: 0px; margin-bottom: 0 !important;">
              Sem telefones adicionados.
            </h3>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import DatasInclusaoAlteracao from "@/../../components-spirit/FormCadastro/DatasInclusaoAlteracao.vue";

import moment from "moment";

export default {
  name: "EmitenteTelefones",
  components: {
    DatasInclusaoAlteracao
  },
  data() {
    return {
      loading: false,
      operadoras: [],
      operadorasDefault: `
        Vivo\n
        Tim\n
        Claro\n
        Oi\n
        Nextel\n
        Embratel\n
      `,
      tiposTelefone: [],
      tiposTelefoneDefault: `
        Comercial\n
        Residencial\n
        TeleFax\n
        Fax\n
        Direto\n
        Celular\n
        Pager\n
        Recado\n
        Financeiro\n
        Financeiro/Master\n
        Master\n
        Administrador\n
        Socio\n
      `,
      telefones: []
    };
  },
  props: ["idEmitente", "telefonesEmitente"],
  async mounted() {
    this.atribuirTelefones();

    let configuracao = await this.getConfiguracaoMaster({
      CONTEUDO_NOME: 'TEXTO',
      NIVEL: '1',
      OPERACAO: 'C',
      USUARIO: 'GERAL',
      SISTEMA: 'GERAL',
      MODULO: 'EMITENTE',
      CAMPO: 'TIPO_OPERADORA',
      CONTEUDO: this.operadorasDefault
    });

    this.operadoras = configuracao.TEXTO.split(/\r?\n/).filter((item) => { return (item) ? true : false; });

    configuracao = await this.getConfiguracaoMaster({
      CONTEUDO_NOME: 'TEXTO',
      NIVEL: '1',
      OPERACAO: 'C',
      USUARIO: 'GERAL',
      SISTEMA: 'GERAL',
      MODULO: 'EMITENTE',
      CAMPO: 'TIPO_TELEFONE',
      CONTEUDO: this.tiposTelefoneDefault
    });

    this.tiposTelefone = configuracao.TEXTO.split(/\r?\n/).filter((item) => { return (item) ? true : false; });
  },
  methods: {
    ...mapActions(["getConfiguracaoMaster"]),
    atribuirTelefones() {
      this.telefones = [];
      if((this.telefonesEmitente) && (this.telefonesEmitente.length)) {
        this.telefonesEmitente.forEach((telefone) => this.telefones.push(telefone));
      }
    },
    formatarData(data) {
      return moment(data, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
    },
    adicionar() {
      this.telefones.push({});

      this.$nextTick(() => {
        let container = this.$el.querySelector(".list-scroll");
        container.scrollTop = container.scrollHeight;
      });
    },
    remover(index) {
      this.telefones.splice(index, 1);
    },
    retornar() {
      return this.telefones;
    }
  }
};
</script>

<style lang="scss" scoped>
.telefone-title {
  position: absolute;
}

@media (min-width: 1200px) {
  .telefone-title {
    margin-top: 3px;
  }
}

@media (max-width: 1199px) {
  .telefone-title {
    margin-top: 3px;
  }
}

.btn-adicionar {
  position: absolute;
}

@media (min-width: 1200px) {
  .btn-adicionar {
    margin-top: -7px;
    right: 23px;
  }
}

@media (max-width: 1199px) {
  .btn-adicionar {
    margin-top: -4px;
    right: 21px;
  }
}

.list-scroll::-webkit-scrollbar {
  width: 10px;
}

.list-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.list-scroll::-webkit-scrollbar-thumb {
  background: #888;
}

.list-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
